import React from 'react';
import { useSearch } from 'hooks';
import { getMinimumTime, isServerless } from 'helpers';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { Container } from '@teko/ds-desktop';

import dynamic from 'next/dynamic';
import { DiscoveryBlock } from '@teko/discovery';
import { ProductCardProps } from '@teko/types/ecommerce';

const FlashSale = dynamic(() =>
  import('@teko/teko-ecommerce').then((mod) => mod.FlashSale),
);

interface FlashSaleBlockProps {
  block: DiscoveryBlock;
  ssrProducts?: ProductCardProps[];
}

export const FlashSaleBlock: React.FC<FlashSaleBlockProps> = ({
  block,
  ssrProducts = [],
}: FlashSaleBlockProps) => {
  const { result: flashSaleData } = useSearch(
    block && {
      ...block.cookedData.paramsObject,
      blockId: block.id,
      pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
    },
    {
      products: ssrProducts,
    },
  );

  const flsProducts =
    flashSaleData?.products && flashSaleData?.products?.length > 0
      ? flashSaleData?.products
      : ssrProducts;

  // get list of end timestamp second
  const endTimeStampSecList: string[] = [];
  (flsProducts || []).forEach((product) => {
    const { flashSale } = product;
    const endTimestampSec = flashSale?.endTimestampSec;
    if (!!endTimestampSec) endTimeStampSecList.push(endTimestampSec);
  });

  return !!flsProducts?.length ? (
    <Container marginBottom="s24">
      <FlashSale
        title={block.label}
        backgroundImage={block.backgroundImageUrl}
        endAt={getMinimumTime(endTimeStampSecList) ?? undefined}
        productsCarousel={{
          products: flsProducts,
          hideCtaButton: false,
          productsPerRow: 4,
          virtual: isServerless(),
        }}
      />
    </Container>
  ) : null;
};
